import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ModalToolbarShareIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon modal-toolbar-share"
        {...props}
    >
        <path
            fill="#48505E"
            fillRule="evenodd"
            d="M18 1.25a3.75 3.75 0 1 1-2.796 6.25l-5.651 3.297a3.773 3.773 0 0 1 0 2.406l5.655 3.294a3.75 3.75 0 1 1-.76 1.297l-5.652-3.295a3.75 3.75 0 1 1 0-4.998l5.651-3.298A3.75 3.75 0 0 1 18 1.25zm0 15.5c-.79 0-1.485.407-1.887 1.024a.624.624 0 0 1-.106.182A2.25 2.25 0 1 0 18 16.75zm-12-7a2.25 2.25 0 1 0 1.942 3.382l.014-.02A2.24 2.24 0 0 0 8.25 12a2.24 2.24 0 0 0-.308-1.132l-.008-.019A2.249 2.249 0 0 0 6 9.75zm12-7a2.25 2.25 0 0 0-1.942 3.382l.008.018A2.249 2.249 0 0 0 20.25 5 2.25 2.25 0 0 0 18 2.75z"
        />
    </svg>
);
const Memo = memo(ModalToolbarShareIcon);
export default Memo;
